import endpoint from "../../config/endpoints";

export const outletTypeJson = {
  showSaveNextBtn: true,
  formPath: "/outlet-type-form",
  apiBaseURL: endpoint.outletType,
  changeExcel: endpoint.exportData,
  screenTitle: "Outlet Type",
  showAddButton: true,
  showPdfDownload: true,
  pdfFileName: "Outlet-Type",
  showExcelDownload: true,
  excelFileName: "Outlet-Type",
  formPathView: "/outlet-type-view",
  tableColumnsToFilter: [
    {
      columnDisplayName: "Name",
      columnKeyName: "name",
      isChecked: true,
    },
    {
      columnDisplayName: "Outlet Count",
      columnKeyName: "outletCount",
      isChecked: true,
    },
  ],
  fieldMeta: [
    {
      label: "Name",
      controlType: "textfield",
      placeHolder: "Name",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      autoFocus: true,
      dataKey: "name",
      isMandatory: true,
      uniqueValidation: true,
    },
    {
      label: "Short Name",
      controlType: "textfield",
      placeHolder: "Short Name",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "shortName",
      isMandatory: true,
    },
  ],

  fieldMetaForSubChannelWise: [
    {
      label: "Sub Channel",
      controlType: "autocomplete",
      placeHolder: "Select Sub Channel",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "subChannelDetail",
      dataKey: "subChannelId",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Name",
      controlType: "textfield",
      placeHolder: "Outlet Type Name",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      autoFocus: true,
      dataKey: "name",
      isMandatory: true,
      uniqueValidation: true,
    },
    {
      label: "Short Name",
      controlType: "textfield",
      placeHolder: "Short Name",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "shortName",
      isMandatory: true,
    },
  ],
};
